import { WORKSPACE_STORAGE_TYPE } from '@bangle.io/constants';
import { useCoreServices } from '@bangle.io/context';
import { getMyMembership } from '@bangle.io/supabase';
import { useAtomValue } from 'jotai';
import React from 'react';

export function useCloudWorkspaceAccess() {
  const core = useCoreServices();
  const wsName = useAtomValue(core.workspaceState.$currentWsName);
  const [workspaceId, setWorkspaceId] = React.useState<string | null>(null);
  const [isViewer, setIsViewer] = React.useState(false);
  const [isOwner, setIsOwner] = React.useState(false);

  React.useEffect(() => {
    if (!wsName) {
      setWorkspaceId(null);
      setIsViewer(false);
      setIsOwner(false);
      return;
    }
    void core.workspaceOps.getWorkspaceInfo(wsName).then(async (info) => {
      if (
        info?.type === WORKSPACE_STORAGE_TYPE.Supabase &&
        typeof info.metadata.workspaceId === 'string'
      ) {
        setWorkspaceId(info.metadata.workspaceId);
        try {
          const membership = await getMyMembership(info.metadata.workspaceId);
          setIsViewer(membership?.role === 'viewer');
          setIsOwner(membership?.role === 'owner');
        } catch {
          setIsViewer(false);
          setIsOwner(false);
        }
        return;
      }
      setWorkspaceId(null);
      setIsViewer(false);
      setIsOwner(false);
    });
  }, [core.workspaceOps, wsName]);

  return { workspaceId, isViewer, isOwner };
}
